// external
import styled from 'styled-components';

// libraries
import { BreakPoint } from '@makemydeal/dr-activities-common';

import type { BaseDealBreakpoint } from '../types';

export const AccessoryActionIconContainer = styled.div`
    margin-top: 1.7rem;
`;

export const AccessoryActionBaseIconContainer = styled.div`
    margin-top: 0;
`;

export const AccessoryFieldsContainer = styled.div<{ $baseBreakPoint: BaseDealBreakpoint; isDealCentralMultiScenario?: boolean }>`
    width: 100%;
    display: grid;
    grid-gap: 0.5rem;
    grid-template-columns: repeat(3, 1fr);

    .text-input-name {
        grid-column: span 2;
    }

    @media (max-width: ${BreakPoint.SMALL}) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: ${BreakPoint.PHONE}) {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }

    &.lease-layout {
        grid-template-columns: repeat(4, 1fr);

        .text-input-name {
            grid-column: span 3;
        }

        @media (max-width: ${BreakPoint.SMALL}) {
            grid-template-columns: repeat(2, 1fr);

            .text-input-name {
                grid-column: span 2;
            }
        }

        @media (max-width: ${BreakPoint.PHONE}) {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
        }
    }
`;
export const BaseContainer = styled.div<{ $baseBreakPoint: BaseDealBreakpoint }>`
    width: 100%;
    display: grid;
    grid-gap: 1rem;
    color: #6d6d6d;
    font-size: 14px;
    grid-template-columns: repeat(7, 1fr) 90px 50px;
    .text-row-1 {
        grid-column: span 2;
    }

    &.lease-layout {
        grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr 1fr 170px;
    }
    @media (max-width: ${({ $baseBreakPoint }) => $baseBreakPoint.TABLET_PORTRAIT}) {
        display: none;
    }
`;
export const AccessoryBaseFieldsContainer = styled.div<{
    $baseBreakPoint: BaseDealBreakpoint;
    isDealCentralMultiScenario?: boolean;
}>`
    width: 100%;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(7, 1fr) 90px 50px;
    align-items: start;
    padding-top: 8px;
    .text-input-name {
        grid-column: span 2;
    }
    .base-accessories-label label,
    label[for='base-accessories-profit-field'] {
        display: none;
    }
    .base-accessories-label div {
        margin-top: 0.5px;
    }
    @media (max-width: ${({ $baseBreakPoint }) => $baseBreakPoint.TABLET_PORTRAIT}) {
        grid-template-columns: repeat(auto-fit, minmax(176px, 1fr));
        max-width: 100%;
        padding-top: 0px;
        .text-input-name {
            grid-column: span 1;
        }
        .base-accessories-label label,
        label[for='base-accessories-profit-field'] {
            display: inline;
        }
        .base-accessories-label div {
            margin-top: -0.5px;
        }
        &.compact-ui {
            grid-template-columns: repeat(auto-fit, minmax(125px, 1fr));
        }
    }

    @media (max-width: ${({ $baseBreakPoint }) => $baseBreakPoint.PHONE}) {
        grid-template-columns: ${({ isDealCentralMultiScenario }) =>
            isDealCentralMultiScenario ? '1fr 1fr' : 'repeat(auto-fit, minmax(125px, 1fr))'};
        gap: 1rem;
        padding-top: 0px;

        .base-accessories-label div {
            margin-top: -0.5px;
        }
    }

    .we-owe-form-control label {
        margin-bottom: 15px;
        @media (max-width: ${({ $baseBreakPoint }) => $baseBreakPoint.PHONE}) {
            margin-bottom: 8px;
        }
    }
    &.lease-layout {
        grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr 1fr 185px;
        .WeOwe-form-control label {
            margin-bottom: 9px;
        }
        @media (max-width: ${({ $baseBreakPoint }) => $baseBreakPoint.TABLET_PORTRAIT}) {
            grid-template-columns: repeat(auto-fit, minmax(125px, 1fr));
            max-width: 100%;
        }

        @media (max-width: ${({ $baseBreakPoint }) => $baseBreakPoint.PHONE}) {
            grid-template-columns: ${({ isDealCentralMultiScenario }) =>
                isDealCentralMultiScenario ? '1fr 1fr' : 'repeat(auto-fit, minmax(130px, 1fr)))'};
            gap: 1rem;
        }
        .we-owe-form-control label {
            margin-bottom: 8px;
        }
    }
`;
export const AccessoriesTotal = styled.div`
    display: flex;
    width: 200px;
    align-items: baseline;
    justify-content: space-between;
`;

export const AccessoriesTotalRow = styled.div`
    display: flex;
    flex-direction: row-reverse;
    align-items: baseline;
    justify-content: space-between;
    margin: 1.1rem 1.1rem 1.1rem 0;

    @media (max-width: ${BreakPoint.SMALL}) {
        margin: 1.1rem 0;
    }
`;

export const AccessoryUpfrontWeOweContainer = styled.div<{ $baseBreakPoint: BaseDealBreakpoint; isDealCentralExperience: boolean }>`
    display: flex;
    gap: 1.5rem;
    align-items: end;

    padding-left: 1rem;

    grid-column: span 2;

    @media (max-width: ${BreakPoint.SMALL}) {
        grid-column: auto;
    }

    @media (max-width: ${BreakPoint.PHONE}) {
        padding: 1rem 0 0 0;
    }

    &.lease-layout {
        @media (max-width: ${BreakPoint.SMALL}) {
            padding: 1rem 0 0 0;
        }

        @media (max-width: ${BreakPoint.PHONE}) {
            align-items: start;
        }
    }
`;

export const AccessoryUpfrontWeOweBaseContainer = styled.div<{
    $baseBreakPoint: BaseDealBreakpoint;
    isDealCentralExperience: boolean;
}>`
    display: grid;
    align-items: start;
    grid-template-columns: 90px 10px;
    margin-top: 0.25rem;
    gap: 0.5rem;
    @media (max-width: ${({ $baseBreakPoint }) => $baseBreakPoint.TABLET_PORTRAIT}) {
        grid-column: span 2;
        margin-top: 22px;
        align-items: start;
    }
    @media (max-width: ${({ $baseBreakPoint }) => $baseBreakPoint.PHONE}) {
        grid-column: span 2;
        margin-top: 0;
        align-items: center;
    }

    @media (min-width: ${({ $baseBreakPoint }) => $baseBreakPoint.SCREEN_SM_MIN}) and (max-width: ${({ $baseBreakPoint }) =>
            $baseBreakPoint.SCREEN_MD_MIN}) {
        margin-top: ${({ isDealCentralExperience }) => (!isDealCentralExperience ? '1.25rem' : 0)};
    }

    @media (min-width: ${({ $baseBreakPoint }) => $baseBreakPoint.SM}) and (max-width: ${({ $baseBreakPoint }) =>
            $baseBreakPoint.LARGE}) {
        margin-top: 1.25rem;
    }

    &.lease-layout {
        grid-template-columns: 80px 75px 24px;
        margin-top: 19px;
        align-items: center;
        gap: 0.25rem;
        @media (max-width: ${({ $baseBreakPoint }) => $baseBreakPoint.TABLET_PORTRAIT}) {
            grid-template-columns: 94px 75px 24px;
            grid-column: span 2;
            margin-top: 19px;
            align-items: center;
        }

        @media (max-width: ${({ $baseBreakPoint }) => $baseBreakPoint.PHONE}) {
            margin-top: 19px;
        }

        @media (min-width: 789px) and (max-width: 1000px) {
            margin-top: 1.5rem !important;
        }

        @media (min-width: ${({ $baseBreakPoint }) => $baseBreakPoint.SM}) and (max-width: ${({ $baseBreakPoint }) =>
                $baseBreakPoint.LARGE}) {
            margin-top: ${({ isDealCentralExperience }) => (isDealCentralExperience ? '1.25rem' : 0)};
        }

        @media (min-width: ${({ $baseBreakPoint }) => $baseBreakPoint.SCREEN_SM_MIN}) and (max-width: ${({ $baseBreakPoint }) =>
                $baseBreakPoint.SCREEN_MD_MIN}) {
            margin-top: ${({ isDealCentralExperience }) => (!isDealCentralExperience ? '1.25rem' : 0)};
        }
    }

    [data-testid^='ids-checkbox-root-upFront'] {
        margin-top: 0.325rem;
    }

    [data-testid^='ids-checkbox-root-weOwe'] {
        margin-top: 0.325rem;
    }

    [data-testid^='manual-accessories-trash-icon'] {
        padding-top: 5px;
    }

    &.lease-layout {
        [data-testid^='ids-checkbox-root-upFront'],
        [data-testid^='ids-checkbox-root-weOwe'] {
            margin-top: 0;
        }

        [data-testid^='manual-accessories-trash-icon'],
        [data-testid^='manual-accessories-restore-icon'] {
            padding-top: 0;
            margin-left: 0.5rem;
        }
    }
`;

export const AddAccessoryActionBaseContainer = styled.div<{ $baseBreakPoint: BaseDealBreakpoint }>`
    padding-top: 1rem;
    padding-bottom: 3rem;
    border-bottom: ${({ theme }) => '1px solid' + theme.tokens.BaseColorGray400};
    white-space: pre;
    @media (max-width: ${({ $baseBreakPoint }) => $baseBreakPoint.TABLET_PORTRAIT}) {
        padding-top: 0rem;
    }
`;

export const ManualAccessoriesErrorContainer = styled.div<{ opened: boolean }>`
    transition: ${({ opened }) => (opened ? 'max-height 0.5s 0.5s;' : 'none')};
    max-height: ${({ opened }) => (opened ? '300px' : 0)};
    overflow: hidden;
    & .MuiAlert-root {
        margin-bottom: 1rem;
    }
`;

export const ManualAccessoriesButtonsContainer = styled.div<{ $baseBreakPoint: BaseDealBreakpoint }>`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 1rem;

    @media (min-width: ${BreakPoint.SMALL}) {
        flex-direction: row;
    }
`;

export const ManualAccessoriesFormBaseContainer = styled.div<{ $baseBreakPoint: BaseDealBreakpoint }>`
    &.first-accessory-form {
        border-top: 2px solid #b2b2b2;
    }
    @media (max-width: ${({ $baseBreakPoint }) => $baseBreakPoint.TABLET_PORTRAIT}) {
        border-top: ${({ theme }) => '1px solid' + theme.tokens.BaseColorGray400};
        padding: 1rem 0;
        &.first-accessory-form {
            border-top: none;
        }
    }

    @media (max-width: ${({ $baseBreakPoint }) => $baseBreakPoint.PHONE}) {
        border-top: ${({ theme }) => '1px solid' + theme.tokens.BaseColorGray400};
        padding: 1rem 0;
        &.first-accessory-form {
            border-top: none;
        }
    }
`;

export const ManualAccessoriesFormRowContainer = styled.div`
    display: flex;
    gap: 1rem;
`;
